import ApiRequest from "./apiRequest";

class AdminService {
  static async getUsers(size, page) {
    const data = await ApiRequest.apiRequest(
      {method: 'GET', url: `users?size=${size}&page=${page}&sort=lastName`}
    );
    return data;
  };

  static async getUsersForDropdowns() {
    const data = await ApiRequest.apiRequest(
      {method: 'GET', url: `users?projection=noPasswords&sort=lastName&size=1000`}
    );
    return data;
  };

  static async addNewUser(payload) {
    const data = await ApiRequest.apiRequest(
      {method: 'POST', url: `auth/register`, body: payload, noResponse: true}
    );
    return data;
  };

  static async updateUser(payload) {
    const data = await ApiRequest.apiRequest(
      {method: 'PUT', url: `users/update`, body: payload, noResponse: true}
    );
    return data;
  };

  static async deleteUser(id) {
    const data = await ApiRequest.apiRequest(
      {method: 'DELETE', url: `users/${id}`, noResponse: true}
    );
    return data;
  };

  static async changePasswordByAdmin(payload) {
    const data = await ApiRequest.apiRequest(
      {method: 'POST', url: `users/admin/password`, body: payload, noResponse: true}
    );
    return data;
  };

  static async changePasswordByUser(payload) {
    const data = await ApiRequest.apiRequest(
      {method: 'POST', url: `users/user/password`, body: payload, noResponse: true}
    );
    return data;
  };
}

export default AdminService;
